if (!customElements.get("custom-cursor")) {
  class CustomCursor extends HTMLElement {
    constructor() {
      super();

      this.ACTIVE_CLASS = "custom-cursor--active";

      this.activeSection = null;
      this.x = 0;
      this.y = 0;
      this.rafId = null;
    }

    connectedCallback() {
      if (this.isDesktop) {
        this.activeSection = this.section;

        if (this.activeSection) this.addListeners();
      }

    }

    addListeners() {
      this.activeSection.addEventListener("pointerover", event => this.showCursor(event));
      this.activeSection.addEventListener("pointermove", event => this.updatePosition(event));
      this.activeSection.addEventListener("pointerout", event => this.hideCursor(event));
    }

    showCursor(event) {
      if (!this.section) return;

      this.x = event.clientX;
      this.y = event.clientY;

      this.render();

      requestAnimationFrame(() => this.classList.add(this.ACTIVE_CLASS));
    }

    updatePosition(event) {
      if (!this.activeSection) return;

      this.x = event.clientX;
      this.y = event.clientY;

      this.queueRender();
    }

    hideCursor(event) {
      if (!this.activeSection) return;
      if (event.relatedTarget && this.activeSection.contains(event.relatedTarget)) return;

      this.classList.remove(this.ACTIVE_CLASS);
    }

    render() {
      this.style.setProperty('--cursor-x', `${this.x}px`);
      this.style.setProperty('--cursor-y', `${this.y}px`);
      this.rafId = null;
    };

    queueRender() {
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => this.render());
    };

    get isDesktop() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    get section() {
      return this.closest("[data-section]");
    }
  }

  customElements.define("custom-cursor", CustomCursor);
}